import { getLocaleFromLandingPathname } from "@/locale";

import { normalizeRoutePathname } from "./adAccountIdUtils";
import { isAdPreviewPath } from "./adPreview";

export function isPublicPath(pathname: string): boolean {
  const normalizedPathname = normalizeRoutePathname(pathname);
  return (
    normalizedPathname === "/" ||
    isAdPreviewPath(normalizedPathname) ||
    getLocaleFromLandingPathname(normalizedPathname) != null ||
    normalizedPathname === "/sitemap.xml" ||
    normalizedPathname === "/promotion" ||
    normalizedPathname === "/unavailable" ||
    normalizedPathname === "/auth" ||
    normalizedPathname.startsWith("/auth/") ||
    normalizedPathname === "/login-error"
  );
}
